export enum DsLibVinciUsersEnums {
  VINCI_COM = '@vinci-construction.com',
  VINCI_FR = '@vinci-construction.fr',
  VC_PARTNER_NET = '@vc-partner.net',
}
